const createArrayOfNumbers = (length: number): number[] => Array.from(Array(length), (_, i) => i + 1);

export { createArrayOfNumbers };
